module.exports = __webpack_public_path__ + "static/media/dadSwatch.6119f6d6.jpg";